const colorCodes = [
  "#B5B6B6",
  "#E60012",
  "#FCC801",
  "#010101",
  "#016966",
  "#A40B5E",
]
  .map(function (a) {
    return { weight: Math.random(), value: a };
  })
  .sort(function (a, b) {
    return a.weight - b.weight;
  })
  .map(function (a) {
    return a.value;
  });

export const ChokkankunIcon = (props: {
  width?: number | string;
  height?: number | string;
  colorIndex: number;
  style?: React.CSSProperties;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width={props.width}
      height={props.height}
      viewBox="0 0 266 487"
      style={props.style}
      enableBackground="new 0 0 266 487"
    >
      <path
        fill={colorCodes[props.colorIndex]}
        opacity="1.000000"
        stroke="none"
        d="
            M267.000000,399.000000 
            C267.000000,400.066650 267.000000,401.133301 266.694214,402.799347 
            C264.394012,412.581116 259.028870,416.987152 249.784500,416.996979 
            C237.848175,417.009674 225.911835,417.002289 213.514282,416.915649 
            C206.268143,416.761078 199.482819,416.612457 192.698349,416.645111 
            C179.129044,416.710419 165.560226,416.875092 151.523102,416.999084 
            C137.361832,417.000793 123.668663,417.002197 109.514297,416.915619 
            C102.268166,416.761047 95.482826,416.612427 88.698364,416.645081 
            C75.129051,416.710449 61.560215,416.875092 47.523087,416.999084 
            C40.221703,416.999573 33.388424,416.999756 26.555143,416.999847 
            C23.721832,416.999908 20.881176,416.867310 18.056549,417.023895 
            C8.617554,417.547180 4.174896,411.626495 1.000000,404.000000 
            C1.000000,402.285858 1.000000,400.571747 1.332249,398.175049 
            C2.776436,385.174103 3.922179,372.858582 4.988836,360.536224 
            C5.743263,351.820892 6.307481,343.088684 7.105032,334.377563 
            C8.337023,320.921417 9.731545,307.480194 10.987772,294.026184 
            C11.754769,285.811768 12.333661,277.579742 13.100450,269.365295 
            C14.356322,255.911362 15.730256,242.468414 16.988600,229.014694 
            C17.772400,220.634659 18.361839,212.236252 19.169374,203.858688 
            C20.386314,191.233932 21.793407,178.627274 22.974634,165.999359 
            C23.804766,157.124802 24.304020,148.219528 25.111158,139.342545 
            C26.334711,125.885796 27.718561,112.443710 28.993074,98.991486 
            C29.755648,90.942719 30.374104,82.879982 31.174166,74.835144 
            C32.396542,62.543819 33.791904,50.269478 34.975742,37.974628 
            C35.798214,29.432829 36.336716,20.864038 37.102287,12.316281 
            C37.570415,7.089507 39.827919,2.999074 45.000000,1.000000 
            C46.066654,1.000000 47.133312,1.000000 48.778522,1.296790 
            C51.304077,3.231650 53.945202,4.487283 55.090946,6.566814 
            C66.831001,27.875137 78.375587,49.291981 89.826973,70.757355 
            C91.092361,73.129288 92.376358,74.076660 95.115234,74.065178 
            C121.102303,73.956215 147.090393,74.054550 173.076630,73.871864 
            C174.721817,73.860306 177.082062,72.403442 177.881790,70.945457 
            C187.911377,52.660503 197.492706,34.126640 207.711777,15.950535 
            C210.735535,10.572330 212.108536,3.589675 219.000000,1.000000 
            C220.066650,1.000000 221.133316,1.000000 222.779877,1.297949 
            C225.560455,3.624605 229.321686,5.403971 229.692535,7.725036 
            C231.328186,17.962229 232.031296,28.351408 232.985596,38.693527 
            C233.759186,47.076939 234.335724,55.478733 235.131393,63.859863 
            C236.361862,76.820770 237.751846,89.766533 238.982956,102.727379 
            C239.779053,111.108688 240.345230,119.511787 241.134048,127.893860 
            C242.369400,141.020920 243.742020,154.135040 244.986450,167.261276 
            C245.765396,175.477631 246.364166,183.711029 247.135727,191.928146 
            C248.383865,205.220596 249.745102,218.502441 250.985977,231.795547 
            C251.768478,240.178253 252.354691,248.579315 253.143112,256.961395 
            C254.377884,270.088562 255.755859,283.202271 256.983063,296.330109 
            C257.782104,304.877747 258.339508,313.448090 259.151215,321.994385 
            C260.366547,334.790314 261.778412,347.567627 262.975677,360.365143 
            C263.790741,369.077301 264.284821,377.819702 265.115021,386.530212 
            C265.513245,390.708740 266.357666,394.844727 267.000000,399.000000 
            M44.008125,205.530823 
            C42.947701,215.598724 41.758553,225.655212 40.865395,235.737930 
            C40.074654,244.664505 39.807503,253.639099 38.943008,262.557007 
            C38.289207,269.301422 35.809841,276.089172 36.334026,282.683441 
            C37.572899,298.268524 35.637287,313.344086 33.191097,328.676910 
            C31.032013,342.210114 31.442636,356.164246 30.899054,369.939606 
            C30.624876,376.887756 33.006577,379.172821 40.137272,379.064636 
            C57.766979,378.797211 75.394135,378.357025 93.024048,378.109070 
            C104.296783,377.950531 115.572639,377.976532 126.847031,377.986633 
            C132.789001,377.991974 138.731079,378.221985 144.672638,378.202728 
            C151.103424,378.181854 157.535202,378.041962 163.963593,377.853424 
            C168.765030,377.712646 173.562973,377.215607 178.360214,377.245239 
            C182.163483,377.268707 185.962326,378.121033 189.764847,378.134766 
            C202.592514,378.181000 215.421310,378.052948 228.248947,377.921387 
            C236.443970,377.837372 239.011536,374.143585 237.711349,366.091400 
            C236.131104,356.304688 234.906036,346.433807 234.114243,336.552307 
            C232.562851,317.191437 231.806427,297.761475 229.990173,278.428772 
            C228.345871,260.926544 229.322372,243.372726 226.396683,225.804199 
            C223.001434,205.415863 222.724167,184.507263 221.115295,163.822800 
            C219.725327,145.952423 218.384262,128.078217 216.978516,110.209106 
            C216.670639,106.295387 214.407364,104.236229 210.506607,103.947334 
            C207.860138,103.751350 205.217743,103.455460 202.567886,103.357849 
            C189.497177,102.876366 176.427094,102.313232 163.351364,102.064186 
            C158.229050,101.966629 153.090424,102.898239 147.962967,102.859856 
            C138.720200,102.790680 129.479309,102.370796 120.239403,102.046906 
            C111.934875,101.755798 103.631706,101.107315 95.329773,101.136658 
            C83.251022,101.179337 71.174026,101.692940 59.096066,101.997269 
            C54.259960,102.119125 50.477612,105.314301 50.093372,110.150932 
            C48.647221,128.354477 47.223309,146.561584 46.036388,164.783325 
            C45.172424,178.046951 44.694290,191.335693 44.008125,205.530823 
            z
          "
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
          M218.531342,1.000000 
          C212.108536,3.589675 210.735535,10.572330 207.711777,15.950535 
          C197.492706,34.126640 187.911377,52.660503 177.881790,70.945457 
          C177.082062,72.403442 174.721817,73.860306 173.076630,73.871864 
          C147.090393,74.054550 121.102303,73.956215 95.115234,74.065178 
          C92.376358,74.076660 91.092361,73.129288 89.826973,70.757355 
          C78.375587,49.291981 66.831001,27.875137 55.090946,6.566814 
          C53.945202,4.487283 51.304077,3.231650 49.178539,1.296790 
          C105.354225,1.000000 161.708450,1.000000 218.531342,1.000000 
          z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
          M267.000000,398.531342 
          C266.357666,394.844727 265.513245,390.708740 265.115021,386.530212 
          C264.284821,377.819702 263.790741,369.077301 262.975677,360.365143 
          C261.778412,347.567627 260.366547,334.790314 259.151215,321.994385 
          C258.339508,313.448090 257.782104,304.877747 256.983063,296.330109 
          C255.755859,283.202271 254.377884,270.088562 253.143112,256.961395 
          C252.354691,248.579315 251.768478,240.178253 250.985977,231.795547 
          C249.745102,218.502441 248.383865,205.220596 247.135727,191.928146 
          C246.364166,183.711029 245.765396,175.477631 244.986450,167.261276 
          C243.742020,154.135040 242.369400,141.020920 241.134048,127.893860 
          C240.345230,119.511787 239.779053,111.108688 238.982956,102.727379 
          C237.751846,89.766533 236.361862,76.820770 235.131393,63.859863 
          C234.335724,55.478733 233.759186,47.076939 232.985596,38.693527 
          C232.031296,28.351408 231.328186,17.962229 229.692535,7.725036 
          C229.321686,5.403971 225.560455,3.624605 223.179901,1.297949 
          C237.652145,1.000000 252.304276,1.000000 267.000000,1.000000 
          C267.000000,133.354218 267.000000,265.708466 267.000000,398.531342 
        z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
          M44.531342,1.000000 
          C39.827919,2.999074 37.570415,7.089507 37.102287,12.316281 
          C36.336716,20.864038 35.798214,29.432829 34.975742,37.974628 
          C33.791904,50.269478 32.396542,62.543819 31.174166,74.835144 
          C30.374104,82.879982 29.755648,90.942719 28.993074,98.991486 
          C27.718561,112.443710 26.334711,125.885796 25.111158,139.342545 
          C24.304020,148.219528 23.804766,157.124802 22.974634,165.999359 
          C21.793407,178.627274 20.386314,191.233932 19.169374,203.858688 
          C18.361839,212.236252 17.772400,220.634659 16.988600,229.014694 
          C15.730256,242.468414 14.356322,255.911362 13.100450,269.365295 
          C12.333661,277.579742 11.754769,285.811768 10.987772,294.026184 
          C9.731545,307.480194 8.337023,320.921417 7.105032,334.377563 
          C6.307481,343.088684 5.743263,351.820892 4.988836,360.536224 
          C3.922179,372.858582 2.776436,385.174103 1.332249,397.746277 
          C1.000000,265.666656 1.000000,133.333313 1.000000,1.000000 
          C15.424507,1.000000 29.743595,1.000000 44.531342,1.000000 
        z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
          M47.991184,416.998718 
          C61.560215,416.875092 75.129051,416.710449 88.698364,416.645081 
          C95.482826,416.612427 102.268166,416.761047 109.525688,417.383911 
          C109.998268,428.239105 109.998268,438.538086 109.998268,449.077271 
          C112.908188,448.325043 115.354393,447.407715 117.875603,447.095032 
          C125.081886,446.201141 134.699326,448.543854 138.106979,454.029999 
          C145.773987,466.373444 143.194305,479.757202 131.000000,488.000000 
          C104.312439,488.000000 77.624878,488.000000 50.354153,487.617981 
          C49.180660,485.475677 48.086452,483.718201 48.076630,481.954681 
          C47.956024,460.303192 47.994122,438.650879 47.991184,416.998718 
        z"
      />
      <path
        fill="#000000"
        opacity="1.000000"
        stroke="none"
        d="
          M151.991196,416.998749 
          C165.560226,416.875092 179.129044,416.710419 192.698349,416.645111 
          C199.482819,416.612457 206.268143,416.761078 213.525681,417.383911 
          C213.998276,428.239105 213.998276,438.538086 213.998276,449.077240 
          C216.908173,448.325012 219.354401,447.407715 221.875610,447.095032 
          C229.081924,446.201172 238.699249,448.543823 242.106979,454.030029 
          C249.773987,466.373352 247.194260,479.757202 235.000000,488.000000 
          C208.312439,488.000000 181.624878,488.000000 154.354156,487.617981 
          C153.180664,485.475677 152.086472,483.718201 152.076645,481.954681 
          C151.956039,460.303192 151.994125,438.650879 151.991196,416.998749 
          z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
          M47.523087,416.999084 
          C47.994122,438.650879 47.956024,460.303192 48.076630,481.954681 
          C48.086452,483.718201 49.180660,485.475677 49.885494,487.617981 
          C33.720573,488.000000 17.441149,488.000000 1.000000,488.000000 
          C1.000000,460.312622 1.000000,432.624969 1.000000,404.468658 
          C4.174896,411.626495 8.617554,417.547180 18.056549,417.023895 
          C20.881176,416.867310 23.721832,416.999908 26.555143,416.999847 
          C33.388424,416.999756 40.221703,416.999573 47.523087,416.999084 
          z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
          M235.468658,488.000000 
          C247.194260,479.757202 249.773987,466.373352 242.106979,454.030029 
          C238.699249,448.543823 229.081924,446.201172 221.875610,447.095032 
          C219.354401,447.407715 216.908173,448.325012 213.998276,449.077240 
          C213.998276,438.538086 213.998276,428.239105 213.986877,417.471863 
          C225.911835,417.002289 237.848175,417.009674 249.784500,416.996979 
          C259.028870,416.987152 264.394012,412.581116 266.694214,403.199371 
          C267.000000,431.226990 267.000000,459.453949 267.000000,488.000000 
          C256.647949,488.000000 246.292633,488.000000 235.468658,488.000000 
          z"
      />
      <path
        fill="#FFFFFF"
        opacity="0.000000"
        stroke="none"
        d="
          M151.523102,416.999084 
          C151.994125,438.650879 151.956039,460.303192 152.076645,481.954681 
          C152.086472,483.718201 153.180664,485.475677 153.885498,487.617981 
          C146.645752,488.000000 139.291504,488.000000 131.468628,488.000000 
          C143.194305,479.757202 145.773987,466.373444 138.106979,454.029999 
          C134.699326,448.543854 125.081886,446.201141 117.875603,447.095032 
          C115.354393,447.407715 112.908188,448.325043 109.998268,449.077271 
          C109.998268,438.538086 109.998268,428.239105 109.986877,417.471863 
          C123.668663,417.002197 137.361832,417.000793 151.523102,416.999084 
          z"
      />
      <path
        fill="#FFFFFF"
        opacity="1.000000"
        stroke="none"
        d="
          M44.026131,205.072021 
          C44.694290,191.335693 45.172424,178.046951 46.036388,164.783325 
          C47.223309,146.561584 48.647221,128.354477 50.093372,110.150932 
          C50.477612,105.314301 54.259960,102.119125 59.096066,101.997269 
          C71.174026,101.692940 83.251022,101.179337 95.329773,101.136658 
          C103.631706,101.107315 111.934875,101.755798 120.239403,102.046906 
          C129.479309,102.370796 138.720200,102.790680 147.962967,102.859856 
          C153.090424,102.898239 158.229050,101.966629 163.351364,102.064186 
          C176.427094,102.313232 189.497177,102.876366 202.567886,103.357849 
          C205.217743,103.455460 207.860138,103.751350 210.506607,103.947334 
          C214.407364,104.236229 216.670639,106.295387 216.978516,110.209106 
          C218.384262,128.078217 219.725327,145.952423 221.115295,163.822800 
          C222.724167,184.507263 223.001434,205.415863 226.396683,225.804199 
          C229.322372,243.372726 228.345871,260.926544 229.990173,278.428772 
          C231.806427,297.761475 232.562851,317.191437 234.114243,336.552307 
          C234.906036,346.433807 236.131104,356.304688 237.711349,366.091400 
          C239.011536,374.143585 236.443970,377.837372 228.248947,377.921387 
          C215.421310,378.052948 202.592514,378.181000 189.764847,378.134766 
          C185.962326,378.121033 182.163483,377.268707 178.360214,377.245239 
          C173.562973,377.215607 168.765030,377.712646 163.963593,377.853424 
          C157.535202,378.041962 151.103424,378.181854 144.672638,378.202728 
          C138.731079,378.221985 132.789001,377.991974 126.847031,377.986633 
          C115.572639,377.976532 104.296783,377.950531 93.024048,378.109070 
          C75.394135,378.357025 57.766979,378.797211 40.137272,379.064636 
          C33.006577,379.172821 30.624876,376.887756 30.899054,369.939606 
          C31.442636,356.164246 31.032013,342.210114 33.191097,328.676910 
          C35.637287,313.344086 37.572899,298.268524 36.334026,282.683441 
          C35.809841,276.089172 38.289207,269.301422 38.943008,262.557007 
          C39.807503,253.639099 40.074654,244.664505 40.865395,235.737930 
          C41.758553,225.655212 42.947701,215.598724 44.026131,205.072021 
          z"
      />
    </svg>
  );
};
